require('./eCommerceKeyBanner.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @constants
const {
    ECOMMERCE_KEY,
    ECOMMERCE_PGBANNER,
} = require('constants/flagBasedFeatures');

class ECommerceKeyBanner extends React.Component {
    render() {
        const { immFlagBasedFeatures } = this.props;
        let content = null;
        if (immFlagBasedFeatures.get(ECOMMERCE_KEY) && immFlagBasedFeatures.get(ECOMMERCE_PGBANNER)) {
            content = (
                <div className="ecommerce-key-banner">
                    <ContentBox>
                        <OKBoxTitle value={<FormattedText value="eCommerceKeyBanner-eCommerceKeyBanner_cesBannerTitle" />} />
                        <div className="ecommerce-key-banner__link">
                            <OKButton
                                modifier="link-complementary"
                                to="/myprofile/keys/ecommerce"
                            >
                                <FormattedText value="eCommerceKeyBanner-eCommerceKeyBanner_cesKeyLinkText" />
                            </OKButton>
                        </div>
                    </ContentBox>
                </div>
            );
        }

        return content;
    }
}

ECommerceKeyBanner.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports.constructor = ECommerceKeyBanner;
module.exports.ECommerceKeyBanner = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), null
)(ECommerceKeyBanner);
